<template>
  <img
      v-if="!showPlaceholder"
      :src="displayedSrc"
      :alt="`tournament-${tournamentId}`"
      @error="onError"
  />
  <v-icon
      v-else
      :size="iconSize"
      :color="iconColor"
  >
    mdi-trophy-variant-outline
  </v-icon>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "TournamentLogo",
  props: {
    tournamentId: { type: [String, Number], required: true },
    iconSize: { type: [Number, String], default: 18 },
    iconColor: { type: String, default: 'var(--text-op-50-platform)' },
  },
  data() {
    return {
      formats: ["webp", "svg", "png"],
      formatIndex: 0,
      displayedSrc: "",
      tournamentPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/tournaments/',
      loadFailed: false,
    }
  },
  computed: {
    ...mapGetters({
      showTournamentLogos: 'settings/getShowTournamentLogos',
    }),
    // Show the placeholder icon when the platform disables tournament logos
    // OR when every image format has failed to load — both cases must collapse
    // to the same neutral visual to avoid empty layout slots.
    showPlaceholder() {
      return !this.showTournamentLogos || this.loadFailed;
    }
  },
  mounted() {
    this.reset();
  },
  watch: {
    tournamentId() { this.reset(); },
    showTournamentLogos() { this.reset(); }
  },
  methods: {
    reset() {
      this.formatIndex = 0;
      this.loadFailed = false;
      if (this.showTournamentLogos) {
        this.displayedSrc = `${this.tournamentPath}${this.tournamentId}.${this.formats[0]}`;
      }
    },
    onError() {
      this.formatIndex += 1;
      if (this.formatIndex < this.formats.length) {
        this.displayedSrc = `${this.tournamentPath}${this.tournamentId}.${this.formats[this.formatIndex]}`;
        return;
      }
      this.loadFailed = true;
    }
  }
}
</script>
